import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SignInComponent } from '../../auth/sign-in/sign-in.component';
import { UtilsService } from '../../shared/utils.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';
import { DataService } from 'src/app/shared/data.service';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../services/language.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        "(window:click)": "onNotificationClick($event)"
    },
    standalone: false
})
export class HeaderComponent implements OnInit {
  openedSidenav: boolean;
  notificationList = new Array<any>();
  routeName = '/home-script';
  @ViewChild('sidenav', { static: true }) sidenav: any;

  @Input()
  isDarkMode = false;
  showBadge = true;

  @Output()
  readonly darkModeSwitched = new EventEmitter<boolean>();

  @Output()
  readonly toggleSidenav = new EventEmitter<boolean>();
  userData: User;
  profileImage: string;
  firstName: string;
  lastName: string;
  isNotificationOpen: any;
  userID: number;
  homeUrl: string;
  unreadCount = 0;

  token: any;
  currentLang: 'en' | 'ar' = 'en';
  showLangMenu = false;

  onDarkModeSwitched({ checked }: MatSlideToggleChange) {
    this.darkModeSwitched.emit(checked);
    if (checked) {
      this.utils.themeName.emit('theme-dark');
    } else {
      this.utils.themeName.emit('theme-light');
    }
  }

  onToggleSidenav() {
    this.toggleSidenav.emit();
  }

  creatNotificationToken() {
    const payload = {
      DeviceId: this.cookie.get('uuid'),
      DeviceInfo: JSON.parse(this.cookie.get('deviceInfo')),
      Platform: 3,
      FirebaseToken: localStorage.getItem('notificationToken')
    };
    this.dataService.post('RegisterDeviceToken', payload).then((data) => {
      if (data.statusCode === 200) {
      }
    });
  }

  toggleNotification($event: any) {
    $event.stopPropagation();
    this.angularFireMessaging.requestPermission.subscribe({
        next: () => {
          this.angularFireMessaging.tokenChanges.subscribe({
            next: (token: any) => {
              console.log('Permission granted!    Token:', token);
              this.token = token;
              localStorage.setItem('notificationToken', token);
              this.creatNotificationToken();
            },
            error: (tokenError) => {
              console.error('Error getting token:', tokenError);
            }
          });
        },
        error: (permissionError) => {
          console.error('Permission denied or error occurred:', permissionError);
        }
      });
    this.isNotificationOpen = !this.isNotificationOpen;

    if (this.isNotificationOpen) {
      this.showBadge = false;
      this.getNotifications();
    }
  }

  onNotificationClick(event: MouseEvent) {
    const notifMenu = document.getElementById('notification-menu');
    const notifIcon = document.getElementById('notification-icon');

    // Close only if click is outside menu and icon
    if (notifMenu && !notifMenu.contains(event.target as Node) &&
        notifIcon && !notifIcon.contains(event.target as Node)) {
      this.isNotificationOpen = false;
      this.cdRef.detectChanges();
    }
  }

  isAuthenticated() {
    return this.authService.isAuthenticated();
  }

  constructor(private router: Router,
              public dialog: MatDialog,
              public utils: UtilsService,
              public authService: AuthService,
              public dataService: DataService,
              private cdRef: ChangeDetectorRef, 
              private angularFireMessaging: AngularFireMessaging,
              private cookie: CookieService,
              private languageService: LanguageService) {
                this.userID = this.authService.getUserData()?.id;
                this.getNotifications();
                this.openedSidenav = false;
                this.userData = this.authService.getUserData();
                this.profileImage = this.userData ? this.userData.picturePath : '';
                this.firstName = this.userData ? this.userData.firstName : '';
                this.lastName = this.userData ? this.userData.lastName : '';
                this.routeName = window.location.pathname;
                this.currentLang = this.languageService.getCurrentLanguage();
                this.homeUrl = this.currentLang === 'ar' ? '/ar/' : '/';
              }

  ngOnInit(): void {
    // Get current language from service
    this.currentLang = this.languageService.getCurrentLanguage();

    this.authService.userDataChanged.subscribe((userData: any) => {
      this.profileImage = userData.picturePath;
      this.firstName = userData.firstName;
      this.lastName = userData.lastName;
      this.cdRef.detectChanges();
    });

    this.authService.newNotification.subscribe((notification: any) => {
      this.showBadge = true;
      this.cdRef.detectChanges();
    });
  }

  navigateTo(page: any) {
    this.router.navigate([page]);
    this.routeName = page;
    if (this.sidenav) {
      this.sidenav.close();
      this.toggle();
    }
  }

  toggle() {
    this.openedSidenav = !this.openedSidenav;
  }

  openSignin() {
    const dialogRef = this.dialog.open(SignInComponent, {
      disableClose: true,
      width: '570px',
    });
    dialogRef.afterClosed().subscribe((status) => {
    });
  }

  markAsRead(id: any) {
    const payload = {
      RecordId: id
    };
    this.dataService.put('notification/MarkNotificationIsRead', payload).then((data: any) => {
      if (data.statusCode === 200) {
        this.getNotifications();
      }
    });
  }

  markAllRead() {
    this.dataService.post('notification/MarkAllNotificationIsRead',[]).then((data: any) => {
      if (data.statusCode === 200) {
        this.getNotifications();
        this.unreadCount = 0;
      }
    });
  }

  getNotifications() {
    if (this.userID) {
      let allRead = true;
      this.dataService.get('GetNotifications/' + this.userID).then((data: any) => {
        if (data.statusCode === 200) {
          this.notificationList = [];
          this.unreadCount = 0;
          const usersData = data.data.records;
          usersData.forEach((notification: any) => {
            this.notificationList.push(notification);
            const date = new Date(notification.sentDate);
            const timeOffsetInMS = date.getTimezoneOffset() * 60000;
            date.setTime(date.getTime() - timeOffsetInMS);
            const formattedDate = date.toLocaleString();
            notification.sentDate = formattedDate;
            
            if (!notification.isRead) {
              this.unreadCount++;
            }
          });
          this.showBadge = this.unreadCount > 0;
          this.checkBadge();
        }
      });
    }
  }

  checkBadge() {
    document.getElementById("checkBadge")?.click();
  }

  toggleLangMenu() {
    this.showLangMenu = !this.showLangMenu;
  }

  switchLanguage(lang: 'en' | 'ar') {
    this.languageService.switchLanguage(lang);
  }

  getLanguageDisplayName(): string {
    return this.languageService.getDisplayName();
  }
}
